<template>
    <auth-layout>
        <header-page title="Membuat Tulisan" />
        <loading-block v-if="loading" />
        <div class="write-form-wrap mt-5" v-else>
            <div class="input-container mb-4">
                <label for="kategori">Kategori</label>
                <select class="form-control" v-bind:class="errors.hasOwnProperty('kategori') ? 'is-invalid' : ''" id="kategori" v-model="form.kategori">
                    <option value="">Pilih kategori</option>
                    <option v-for="item in categories" :value="item.value" v-bind:key="item.id">{{ item.name }}</option>
                </select>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('kategori')">
                    {{ errors['kategori'][0] }}
                </div>
            </div>
            <div class="input-container mb-4">
                <div class="input-wrap title">
                    <clean-input v-model="form.judul" :has-error="errors.hasOwnProperty('judul')" placeholder="Tulis judul artikel di sini"/>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('judul')">
                        {{ errors['judul'][0] }}
                    </div>
                    <div class="remaining-text" v-else>
                        {{ 75 - form.judul.length }}/75 Remaining
                    </div>
                </div>
            </div>
            <div class="input-container mb-4">
                <div class="input-wrap desc">
                    <clean-input v-model="form.deskripsi" :has-error="errors.hasOwnProperty('deskripsi')" placeholder="Tulis summary artikel di sini"/>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('deskripsi')">
                        {{ errors['deskripsi'][0] }}
                    </div>
                    <div class="remaining-text" v-else>
                        {{ 175 - form.deskripsi.length }}/175 Remaining
                    </div>
                </div>
            </div>
            <div class="input-container mb-4">
                <div class="d-flex">
                    <label for="tag">Tag</label>
                    <tooltip description="Pisahkan dengan tekan enter pada keyboard dan tanpa tanda #"/>
                </div>
                <!-- <input-tag v-model="form.tag" id="tag" @input="Checktag($event)" v-bind:class="errors.hasOwnProperty('tag') ? 'is-invalid' : ''"></input-tag> -->


                <div class="vue-input-tag-wrapper">
                 <input type="text" v-model="tags" id="tag" @input="Checktag($event)" v-bind:class="errors.hasOwnProperty('tag') ? 'is-invalid' : ''">
                
                <div class="ma-top"> 
                <span class="input-tag " v-for="itag in form.tag" :key="itag">
                     <span>{{ itag }}</span>
                </span>
                </div>  
                </div>

                  
                <div class="remaining-text">
                   Pisahkan dengan koma dan tanpa tanda #
                </div>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('tag')">
                    {{ errors['tag'][0] }}
                </div>
            </div>
            <div class="mb-4">
                <div class="image-container pointer" v-bind:class="errors.hasOwnProperty('media') ? 'is-invalid' : ''" @click="openMedia({location: 'base', section: 0})">
                    <div class="image-wrap" v-if="isEmpty(form.media)">
                        <div class="select-image">
                            <i class="bi bi-image"></i>
                            <div class="ml-2">Sisipkan Gambar</div>
                        </div>
                    </div>
                    <div v-else>
                        <img alt="" :src="form.media.fullpath">
                        <button class="change-image btn btn-primary" @click="openMedia({location: 'base', section: 0})"><i class="bi bi-arrow-repeat"></i></button>
                    </div>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('media')">
                        {{ errors['media'][0] }}
                    </div>
                </div>
                <div class="text-center" v-if="!isEmpty(form.media)">{{ form.media.judul }}</div>
            </div>
            <div class="mt-2 mb-4">
            

                <editor
                    v-bind:class="errors.hasOwnProperty('konten') ? 'is-invalid' : ''"
                    v-model="form.konten"
                    id="konten"
                   
                    :init="{
                        paste_as_text: true,
                        height: 250,
                        menubar: false,
                        branding: false,
                        statusbar: false,
                        plugins: [
                           'advlist autolink lists link image charmap print preview anchor',
                           'searchreplace visualblocks code fullscreen',
                           'insertdatetime media table paste code help wordcount'
                        ],
                        toolbar:
                           'undo redo | bold italic underline | bullist numlist | \
                           alignleft aligncenter alignright alignjustify',
                        contextmenu: false,
                        setup: function (editor) {
                            editor.on('keyup', function (e) {
                                  onCountArticle(e)
                            });
                        }
                    }"
                />

                <div class="tox-statusbar" v-show="show_count">
                    <div class="tox-statusbar__text-container">
                        <div role="navigation" data-alloy-tabstop="true" class="tox-statusbar__path" aria-disabled="false">
                            <div role="button" data-index="0" tab-index="-1" aria-level="1" tabindex="-1" class="tox-statusbar__path-item" aria-disabled="false">p</div>
                        </div>

                        <button type="button" tabindex="-1" data-alloy-tabstop="true" class="tox-statusbar__wordcount">{{ count_text }} WORDS</button>

                        


                    </div>
                    <div title="Resize" data-alloy-tabstop="true" tabindex="-1" class="tox-statusbar__resize-handle">
                        <svg width="10" height="10" focusable="false"><g fill-rule="nonzero"><path d="M8.1 1.1A.5.5 0 119 2l-7 7A.5.5 0 111 8l7-7zM8.1 5.1A.5.5 0 119 6l-3 3A.5.5 0 115 8l3-3z"></path></g></svg>
                    </div>
                </div>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('konten')">
                    {{ errors['konten'][0] }}
                </div>
            </div>
            <div class="row mb-5" v-if="sections.length === 0">
                
                <div class="col-12 text-right">
                    <button class="btn btn-primary" @click="addSection"><i class="bi bi-plus-lg"></i> Tambah Section</button>
                    
                    <div class="btn-group" role="group">
                        <button id="btnGroupDrop1" type="button" class="btn btn-primary btn-border dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Embed
                        </button>
                        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a class="dropdown-item" href="#"  @click="previewEmbed('Youtube')"><img width="15" src="/assets/images/youtube.png"> Youtube</a>
                          <a class="dropdown-item" href="#" @click="previewEmbed('Instagram')"><img  width="15" src="/assets/images/instagram.png"> Instagram</a>
                          <a class="dropdown-item" href="#" @click="previewEmbed('Tiktok')"><img  width="15" src="/assets/images/tiktok.png"> Tiktok</a>
                          <a class="dropdown-item" href="#" @click="previewEmbed('Twitter')"><img  width="15" src="/assets/images/twitter_x.png"> X (Twitter)</a>
                          <a class="dropdown-item" href="#" @click="previewEmbed('Serbada')"><img  width="15" src="/assets/images/serbada.png"> Serbada</a>
                        </div>
                    </div>
                     
                </div>
            </div>
            <div>
                <div v-for="(item, index) in sections" v-bind:key="item.id" class="pull-left full section-container mb-5">
                    <div class="button-close pull-left">
                        <div class="btn-move-section">
                            <button class="btn btn-primary" @click="upSection(index)" v-if="sections.length > 1 && index > 0"><i class="bi bi-arrow-up-circle"></i></button>
                            <button class="btn btn-primary" @click="downSection(index)" v-if="sections.length - index > 1"><i class="bi bi-arrow-down-circle"></i></button>
                            <button class="btn btn-primary" @click="removeSection(index)"><i class="bi bi-dash-circle"></i></button>
                        </div>
                    </div>
                    <div class="input-container mb-4 pull-left">
                        <div class="input-wrap sub pull-left">
                            <clean-input v-model="sections[index].title" :has-error="errors.hasOwnProperty(`sections.${index}.title`)" :placeholder="'Tulis Sub Judul Ke-'+ (index+1) +' Di Sini..'"/>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty(`sections.${index}.title`)">
                                {{ errors[`sections.${index}.title`][0] }}
                            </div>
                            <div class="remaining-text" v-else>
                                {{ 75 - sections[index].title.length }}/75 Remaining
                            </div>
                        </div>
                    </div>
                    <div class="mb-4 pull-left">
                        <div class="image-container pointer" v-bind:class="errors.hasOwnProperty(`sections.${index}.media`) ? 'is-invalid' : ''" @click="openMedia({location: 'section', section: index})">
                            <div class="image-wrap" v-if="isEmpty(sections[index].media)" >
                                <div class="select-image">
                                    <i class="bi bi-image"></i>
                                    <div class="ml-2">Sisipkan Gambar</div>
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="sections[index].type === 'image'" v-bind:class="errors.hasOwnProperty(`sections.${index}.media.image`) ? 'is-invalid' : ''">
                                    <img :alt="sections[index].media.title" :src="sections[index].media.image">
                                    <button class="change-image btn btn-primary" @click="openMedia({location: 'section', section: index})"><i class="bi bi-arrow-repeat"></i></button>
                                    <div class="invalid-feedback" v-if="errors.hasOwnProperty(`sections.${index}.media.image`)">
                                        {{ errors[`sections.${index}.media.image`][0] }}
                                    </div>
                                </div>
                            </div>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty(`sections.${index}.media`)">
                                {{ errors[`sections.${index}.media`][0] }}
                            </div>
                        </div>
                        <div v-if="sections[index].type === 'image'">
                            <div class="text-center">{{ sections[index].media.title }}</div>
                        </div>
                    </div>
                    <div class="mb-4 pull-left" v-if="!sections[index].loading">
                        <div class="show-description pointer" v-if="sections[index].descShow === false" @click="sections[index].descShow = !sections[index].descShow">
                            <i class="bi bi-plus-square"></i><div class="ml-2">Tulis deskripsi sub judul ke-{{index+1}}</div>
                        </div>

                        <div class="mb-4" v-if="!sections[index].loading">
                            <div class="show-description pointer" v-if="sections[index].descShow === false" @click="sections[index].descShow = !sections[index].descShow">
                                <i class="bi bi-plus-square"></i><div class="ml-2">Tulis deskripsi sub judul ke-{{index+1}}</div>
                            </div>
                            <div class="wrap-text-editor" v-else>
                                <span class="close-button-editor" @click="sections[index].descShow = !sections[index].descShow"><i class="bi bi-arrows-angle-contract"></i></span>

                                <editor
                                    ref="editor"
                                    :key="sections[index].id"
                                    v-bind:class="errors.hasOwnProperty(`sections.${index}.description`) ? 'is-invalid' : ''"
                                    v-model="sections[index].description"
                                  
                                    :init="{
                                        paste_as_text: true,
                                        height: 150,
                                        menubar: false,
                                        branding: false,
                                        statusbar: false,
                                        plugins: [
                                           'advlist autolink lists link image charmap print preview anchor',
                                           'searchreplace visualblocks code fullscreen',
                                           'insertdatetime media table paste code help wordcount'
                                        ],
                                        toolbar:
                                           'undo redo | bold italic underline | bullist numlist | \
                                           alignleft aligncenter alignright alignjustify',
                                        contextmenu: false,
                                        setup: function (editor) {
                                            editor.on('keyup', function (e) {
                                                  onCountArticle(e)
                                            });
                                        }
                                    }"
                                />
                                <div class="tox-statusbar" v-show="show_count">
                                    <div class="tox-statusbar__text-container">
                                        <div role="navigation" data-alloy-tabstop="true" class="tox-statusbar__path" aria-disabled="false">
                                            <div role="button" data-index="0" tab-index="-1" aria-level="1" tabindex="-1" class="tox-statusbar__path-item" aria-disabled="false">p</div>
                                        </div>

                                        <button type="button" tabindex="-1" data-alloy-tabstop="true" class="tox-statusbar__wordcount">{{ count_text }} WORDS</button>

                                        


                                    </div>
                                    <div title="Resize" data-alloy-tabstop="true" tabindex="-1" class="tox-statusbar__resize-handle">
                                        <svg width="10" height="10" focusable="false"><g fill-rule="nonzero"><path d="M8.1 1.1A.5.5 0 119 2l-7 7A.5.5 0 111 8l7-7zM8.1 5.1A.5.5 0 119 6l-3 3A.5.5 0 115 8l3-3z"></path></g></svg>
                                    </div>
                                </div>
                                <div class="invalid-feedback" v-if="errors.hasOwnProperty(`sections.${index}.description`)">
                                    {{ errors[`sections.${index}.description`][0] }}
                                </div>
                            </div>
                        </div>


                        
                    </div>
                    <div class="mb-4 text-center" v-else>
                        <pulse-loader color="#EC550E"></pulse-loader>
                    </div>
                    <div class="row btn-move-wrap full pull-left">
                        
                        <div class="col-12 text-right" v-if="sections.length === index+1">
                            <button class="btn btn-primary" @click="addSection"><i class="bi bi-plus-lg"></i> Tambah Section</button>

                            <div class="btn-group" role="group">
                                <button id="btnGroupDrop1" type="button" class="btn btn-primary btn-border dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  Embed
                                </button>
                                <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                  <a class="dropdown-item" href="#"  @click="previewEmbed('Youtube')"><img width="15" src="/assets/images/youtube.png"> Youtube</a>
                                  <a class="dropdown-item" href="#" @click="previewEmbed('Instagram')"><img  width="15" src="/assets/images/instagram.png"> Instagram</a>
                                  <a class="dropdown-item" href="#" @click="previewEmbed('Tiktok')"><img  width="15" src="/assets/images/tiktok.png"> Tiktok</a>
                                  <a class="dropdown-item" href="#" @click="previewEmbed('Twitter')"><img  width="15" src="/assets/images/twitter_x.png"> X (Twitter)</a>
                                  <a class="dropdown-item" href="#" @click="previewEmbed('Serbada')"><img  width="15" src="/assets/images/serbada.png"> Serbada</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="button-save position-alert">
                <h8 class="" v-if="btnSubmit ==true">Kamu telah mencapai limit 15 artikel pending. Artikel ini bisa kamu simpan di draft dan disubmit setelah artikel lainnya terbit.</h8>
            </div>    
            <div class="button-save">
                <button v-if="article_count == true" class="btn btn-primary main-button pill-button submit" data-toggle="tooltip" title="Submit!" @click="previewArticle()"><i class="bi bi-cursor"></i> Submit</button>

                 <button v-else class="btn btn-default main-button pill-button button-disable" data-toggle="tooltip" title="Submit!" ><i class="bi bi-cursor" :disabled="btnSubmit"></i> Submit</button>

                <button class="btn btn-primary main-button pill-button" data-toggle="tooltip" title="Save Draft!" @click="handleSubmit(true)"><i class="bi bi-archive"></i></button>
            </div>
        </div>
        <upload-media @media="handleMedia"/>
        <preview-embed :loading="loading" :embed="embed" @getIframe="getEmbed"></preview-embed>
        <preview-article :data="form" :sections="sections" @submit="handleSubmit" @recaptcha="handleRecaptcha" :loading="loading"/>
    </auth-layout>
</template>

<style scoped>
.pull-left{
    float: left;
}    
.write-form-wrap {
    padding: 2%;
    background-color: #fff;
    border-radius: 5px;
}
.position-alert{
    bottom: 59px!important;
    padding: 0px 29px!important;
}
.button-disable {
    width: 110px!important;
    font-size: 15px!important;
    background-color: #cccccc!important;
    color: #2f2c2c!important;
    border: 1px solid #0e0e0e!important;

}    
/*FORM*/
.image-container {
    border: 2px dashed #eee;
    position: relative;
}
.image-container img {
    width: 100%;
    height: auto;
}
.change-image {
    position: absolute;
    right: 15px;
    top: 15px;
    border-radius: 50%;
    padding: 4px 10px;
}
.change-image i {
    font-size: 20px;
    width: 20px;
    height: 20px;
}
.image-wrap {
    display: flex;
    justify-content: center;
    padding: 100px;
}
.select-image {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #969696;
}
.section-container {
    position: relative;
}
.button-close {
    position: absolute;
    right: 0;
    top: 40px;
}
.input-container .remaining-text {
    color: #6c757d;
    font-size: 12px;
}
.input-wrap.title .clean-input {
    font-size: 30px;
    font-weight: bold;
    width: 100%;
    height:100%;
    border-color: transparent;
}
.input-wrap.sub .clean-input {
    font-size: 25px;
    font-weight: bold;
}
.input-wrap .clean-input {
    display: flow-root;
    width: auto;
    border: none;
    font-weight: 300;
    font-size: 20px;
}
.input-wrap .clean-input:focus-visible {
    outline: transparent;
}
.input-container select {
    border-bottom: 1px solid #eee;
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: unset;
    padding: 0;
    font-size: 16px;
}
.show-description {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border: 2px solid #eee;
}
.was-validated .form-control:invalid, .form-control.is-invalid {
    background-position: right calc(0.4em + 1.1875rem) center;
    border-bottom: 1px solid #e3342f;
}
.wrap-text-editor {
    position: relative;
}
.close-button-editor {
    position: absolute;
    top: 5px;
    right: 10px;
    z-index: 9999;
    font-size: 20px;
    color: #ec550e;
    cursor: pointer;
}
.button-save {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: fixed;
    right: 0;
    bottom: 0;
    background: #fff;
    box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;
    z-index: 99;
    width: 100vw;
}
.button-save button {
    margin: 10px;
    font-size: 22px;
    width: 40px;
    height: 40px;
    padding: 0;
    background: #fff;
    color: #ec550e;
}
.button-save button.submit {
    width: 110px;
    font-size: 15px;
    background-color: #ec550e;
    color: #fff;
}
.btn-move-section button {
    font-size: 20px;
    padding: 0;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    line-height: unset;
    text-align: center;
}
.btn-move-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
}
.input-container .vue-input-tag-wrapper {
    border-bottom: 1px solid #eee;
    border-top: none;
    border-right: none;
    border-left: none;
    border-radius: unset;
    padding-left: 0 !important;
}
.input-container .vue-input-tag-wrapper.is-invalid {
    border-bottom: 1px solid #e3342f;
}
.image-container.is-invalid {
    border: 2px dashed #e3342f;
}
.image-container.is-invalid .invalid-feedback {
    display: block;
    position: absolute;
}

#tag,#tag:focus {
        border: none!important;
    width: 100%!important;
}
.ma-top{
    float: left;
    margin: 5px 0px 0px;
}
</style>
<style>

.btn-border {
    color: #EC550E!important;
    background-color:#fff!important;
    border-color: #EC550E;
}

.iframe-dotted{
    display: flex;
    justify-content: center;
    padding: 15px 0px;
    border: 2px dotted #989898;
    margin: 0px 0px 10px;
}

.tox-tinymce {
    border-radius: 5px !important
}
.tox-control-wrap {
    display: none;
}

.btn-border {
    color: #EC550E!important;
    background-color:#fff!important;
    border-color: #EC550E;
}

.iframe-dotted{
    display: flex;
    justify-content: center;
    padding: 15px 0px;
    border: 2px dotted #989898;
    margin: 0px 0px 10px;
}
.tox-statusbar{
    border-bottom: 1px solid #ddd;
    float: left;
    width: 100%;
    margin: 0px 0px 16px;
    border-right: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-radius: 0px 0px 6px 6px;
}

.tox-statusbar__text-container{
    float: left;
    width: 98%;
}



.tox-statusbar__path{
  width:90%;
 float: left;
}

.tox-statusbar__path-item{
    float: left;
    padding: 0px 7px;
    font-size: 12px;
    color: #6e6c6c;
}

.tox-statusbar__wordcount{
    border: none;
    background: none;
    float: right;
    width: 10%;
    font-size: 12px;
    color: #6e6c6c;
    padding: 2px 0px;
}

.tox-statusbar__resize-handle{
    float: left;
    width: 2%;
}

.section-one{
    float: left;
    width: 100%;
}
.ck-editor__editable_inline:not(.ck-comment__input *) {
    min-height: 400px;
    overflow-y: auto;
}
.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable), .ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable) {
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
}

.full{
    width: 100%;
}
</style>
<script>
import Editor from '@tinymce/tinymce-vue'
import axios from "axios";
import _ from 'lodash';
import $ from 'jquery';
import PreviewEmbed from "../../../mobile/components/PreviewEmbed.vue"
import PreviewArticle from "../../components/PreviewArticle.vue"
import UploadMedia from "../../components/UploadMedia";
import CleanInput from "../../components/CleanInput";
import Tooltip from "../../components/Tooltip";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
    data() {
        return {
           
            loading: true,
            uploadForm: false,
            categories: [],
            embed:'',
            iframe:'',
            tags:'',
            form: {
                judul: '',
                deskripsi: '',
                konten: '',
                kategori: '',
                tag: [],
                media: {},
                recaptcha: ''
            },
            show_count:false,
            count_text:0,
            sections: [],
            descMedia: false,
            location: {
                location: '',
                section: 0
            },
            errors: [],
            article_count:0,
            btnSubmit:false,
        }
    },
    components: {
        'editor': Editor,
         // ckeditor: CKEditor.component,
        'preview-article': PreviewArticle,
        'preview-embed': PreviewEmbed,
        'upload-media': UploadMedia,
        'clean-input': CleanInput,
        Tooltip,
        PulseLoader
    },
    async mounted() {
        $('[data-toggle="tooltip"]').tooltip();
        await this.getCategory();
        this.loading = false;
        setTimeout(() => this.show_count = true, 2000);
        this.CheckLimitContent();
    },
    methods: {

           async onReady( editor )  {
              //console.log( 'Editor was initialized', editor );
                // Insert the toolbar before the editable area.
                editor.ui.getEditableElement().parentElement.insertBefore(
                    editor.ui.view.toolbar.element,
                    editor.ui.getEditableElement()
                );

                 editor.model.schema.addChildCheck((context, childDefinition) => {
                    if (childDefinition.name === 'table') {
                      return false;
                    }
                  });
                  
                  editor.editing.view.document.on('clipboardInput', (evt, data) => {
                    const dataTransfer = data.dataTransfer;
                    const content = dataTransfer.getData('text/html');
                    
                    // Jika konten mengandung tabel, mencegah penempelan
                    if (content && content.includes('<table')) {
                      evt.stop();
                    }
                  });
              
                 

            },
          async CheckLimitContent(){
           const token = this.$cookies.get('token');
            await axios.get('/api/article/status/publish', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.article_count = response.data;
                      
                    if(this.article_count == true)
                    {
                      this.btnSubmit = false;
                    }else{
                       this.btnSubmit = true;  
                    }  
                    


                })
                .catch((error) => {

                });

        },
         Checktag($event){

            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                 this.form.tag =  $event.target._value.split(',');
            }, 800);
           
           
   
        },
         async onCountArticle(e){
            var text = e.currentTarget.innerText;
            const data = {
                sections: this.sections,konten:text
            }
            const token = this.$cookies.get('token');
            axios.post(`/api/article/count`, data, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.count_text = response.data.count;
                    
                })
                .catch((error) => {

                });
        },
        async getCategory () {
            const token = this.$cookies.get('token');
            await axios.get('/api/article/category', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.categories = response.data
                })
                .catch((error) => {

                });
        },
        getEmbed(data){
            
            var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
            tinymce.activeEditor.insertContent(data);
            $('#previewEmbed').modal('hide');
        },
        handleSubmit(draft = false) {
            const token = this.$cookies.get('token');
            const data = {
                ...this.form, sections: this.sections, draft: draft
            }
            this.errors = [];
            this.loading = true;
            axios.post(`/api/article`, data, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    });
                    // Handle redirect
                    if(draft) {
                        this.$router.push({name: 'post-draft'});
                    } else {
                        this.$router.push({name: 'post-pending'});
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    $('#previewArticle').modal('hide');
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                        if(error.response.status === 422) {
                            window.scrollTo(0,0);
                            this.errors = error.response.data.errors;
                            setTimeout(()=>{
                                this.errors = [];
                            },15000);
                        }
                    }
                    this.loading = false;
                    // Reset recaptcha for load new
                    this.$refs.recaptcha.reset();
                });
        },
        handleRecaptcha(response) {
            if(response) {
                this.form.recaptcha = response
            }
        },
        handleMedia(e) {
            if(!this.isEmpty(e)) {
                if(this.location.location === 'base') {
                    this.form.media = {
                        photo: e.file[0].oriphoto,
                        fullpath: e.file[0].orifullpath,
                        cropphoto: null,
                        fullpathcrop: null,
                        captionphoto: e.captionphoto,
                        judul: e.judul
                    };
                } else {
                    this.sections[this.location.section].media = {
                        image: e.file[0].orifullpath,
                        title: e.judul
                    };
                }
                this.location = {
                    location: '',
                    section: 0
                };
            }
        },
        handleRemoveMedia() {
            if(this.form.media) {
                this.form.media = {};
            }
        },
        openMedia(location) {
            this.location = location;
            $('#mediaGallery').modal({
                backdrop: 'static',
                keyboard: false
            });
        },
        previewEmbed(embed) {
            this.embed = embed;
            this.param_message = '';
            $('#previewEmbed').modal({
                backdrop: 'static',
                keyboard: false
            });

        },
        previewArticle() {
            $('#previewArticle').modal({
                backdrop: 'static',
                keyboard: false
            });
        },
        addSection() {
            var lastId;
            if(this.sections.length > 0) {
                let orderByHigh = _.orderBy(this.sections, ['id'], ['asc']);
                let last = _.last(orderByHigh);
                lastId = last.id;
            } else {
                lastId = 0;
            }
            this.sections.push({
                id: lastId + 1,
                title: '',
                type: 'image',
                media: {},
                description: '',
                descShow: true,
                loading: false
            });

            console.log(this.sections)
        },
        removeSection(index) {
            this.sections.splice(index, 1);
        },
        upSection(index) {
            this.sections[index].loading = true
            this.sections[index-1].loading = true

            let previousSbiling = this.sections[index - 1]
            this.sections.splice(index - 1, 1)
            this.sections.splice(index, 0, previousSbiling)

            var self = this;
            setTimeout(() => {
                self.sections[index].loading = false
                self.sections[index-1].loading = false
            }, 500);
        },
        downSection(index) {
            this.sections[index].loading = true
            this.sections[index+1].loading = true

            let target = this.sections[index]
            this.sections.splice(index, 1)
            this.sections.splice(index + 1, 0, target)

            var self = this;
            setTimeout(() => {
                self.sections[index].loading = false
                self.sections[index+1].loading = false
            }, 500);
        },
        isEmpty (value) {
            return _.isEmpty(value);
        }
    }
}
</script>

